import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CalendarIcon, MapPinIcon, SearchIcon, UsersIcon } from 'lucide-react';
import { Button } from '../ui/Button';
import { useLocale } from '../../contexts/LocaleContext';
import { cn } from '../../utils/cn';
import type { Fulfillment } from '../../types/chef';
export function OccasionSearch({
  variant = 'panel'
}: {
  variant?: 'panel' | 'bar';
}) {
  const navigate = useNavigate();
  const {
    t
  } = useLocale();
  const [where, setWhere] = useState('Phrom Phong, Bangkok');
  const [when, setWhen] = useState('2026-09-19');
  const [guests, setGuests] = useState(6);
  const [fulfillment, setFulfillment] = useState<Fulfillment>('in_home');
  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    const params = new URLSearchParams({
      where,
      when,
      guests: String(guests),
      fulfillment
    });
    navigate(`/discover?${params.toString()}`);
  };
  return <form onSubmit={submit} className={cn('rounded-2xl border border-hairline bg-surface p-3 shadow-lift', variant === 'bar' && 'shadow-float')} data-id="element-567" data-mp="2dxvp7vp3nry6">
      <div className="mb-3 flex gap-1.5 rounded-full bg-oat p-1" role="radiogroup" aria-label="How should the chef work?" data-id="element-568" data-mp="1gw8cyjg2vj9k">
        {[{
        id: 'in_home' as Fulfillment,
        label: t('home.inHome')
      }, {
        id: 'delivery' as Fulfillment,
        label: t('home.delivery')
      }].map(option => <button key={option.id} type="button" role="radio" aria-checked={fulfillment === option.id} onClick={() => setFulfillment(option.id)} className={cn('flex-1 rounded-full px-4 py-2 text-[13px] font-semibold transition-colors duration-150 ease-out', fulfillment === option.id ? 'bg-surface text-ink shadow-lift' : 'text-ink-2 hover:text-ink')} data-id="element-569" data-mp="24qj7djx0tv1c">
            {option.label}
          </button>)}
      </div>

      <div className="grid gap-2 sm:grid-cols-2 xl:grid-cols-[1.3fr_1fr_0.8fr_auto]" data-id="element-570" data-mp="1g7ntmy5t2a2g">
        <label className="flex items-center gap-2 rounded-lg border border-hairline px-3 py-2.5" data-id="element-571" data-mp="1l5fuihofh6is">
          <MapPinIcon className="h-4 w-4 shrink-0 text-ink-3" aria-hidden="true" data-id="element-572" data-mp="1p711xni70sll" />
          <span className="min-w-0 flex-1" data-id="element-573" data-mp="1ty0yusrbbao3">
            <span className="block text-[11px] font-semibold uppercase tracking-[0.05em] text-ink-3" data-id="element-574" data-mp="1tz2mdwpilpmp">{t('home.searchWhere')}</span>
            <input value={where} onChange={e => setWhere(e.target.value)} placeholder="Neighbourhood or postcode" className="w-full bg-transparent text-sm text-ink placeholder:text-ink-3 focus:outline-none" data-id="element-575" data-mp="1yzgnsvwm21br" />
          </span>
        </label>

        <label className="flex items-center gap-2 rounded-lg border border-hairline px-3 py-2.5" data-id="element-576" data-mp="ehinl6wpeutv">
          <CalendarIcon className="h-4 w-4 shrink-0 text-ink-3" aria-hidden="true" data-id="element-577" data-mp="ij47hc7no9dk" />
          <span className="min-w-0 flex-1" data-id="element-578" data-mp="il6xhw8t62ia">
            <span className="block text-[11px] font-semibold uppercase tracking-[0.05em] text-ink-3" data-id="element-579" data-mp="azuxphv8m8nz">{t('home.searchWhen')}</span>
            <input type="date" value={when} onChange={e => setWhen(e.target.value)} className="w-full bg-transparent text-sm text-ink focus:outline-none" data-id="element-580" data-mp="67bmgrk0vpmc" />
          </span>
        </label>

        <label className="flex items-center gap-2 rounded-lg border border-hairline px-3 py-2.5" data-id="element-581" data-mp="tyz5knb1lwe2">
          <UsersIcon className="h-4 w-4 shrink-0 text-ink-3" aria-hidden="true" data-id="element-582" data-mp="oyunwtyeevm9" />
          <span className="min-w-0 flex-1" data-id="element-583" data-mp="kxr6i30pcrix">
            <span className="block text-[11px] font-semibold uppercase tracking-[0.05em] text-ink-3" data-id="element-584" data-mp="kwg344b65lsc">{t('home.searchGuests')}</span>
            <input type="number" min={1} max={40} value={guests} onChange={e => setGuests(Number(e.target.value))} className="tnum w-full bg-transparent text-sm text-ink focus:outline-none" data-id="element-585" data-mp="g0sdjnsryqmb" />
          </span>
        </label>

        <Button type="submit" variant="action" size="lg" className="w-full whitespace-nowrap sm:col-span-2 xl:col-span-1 xl:w-auto" data-id="element-586" data-mp="x6xgx79fozhd">
          <SearchIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-587" data-mp="jgk7f0gw9cpx" />
          {t('home.searchCta')}
        </Button>
      </div>
    </form>;
}